module.exports = __webpack_public_path__ + "resources/img/bg_tcc_inquiry.4c2d42d1997a0d336ccda7ccfc7aa289.jpg";